import { AuthService } from './../../services/auth.service';
import { MyListService } from './../../services/my-list.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ShareFokoDialogComponent } from '../dialogs/share-foko-dialog/share-foko-dialog.component';

@Component({
  selector: 'app-my-fokos',
  templateUrl: './my-fokos.component.html',
  styleUrls: ['./my-fokos.component.css']
})
export class MyFokosComponent implements OnInit {

  constructor(public myListService: MyListService, public dialog: MatDialog) { }

  shareFoko(foko) {
    this.dialog.open(ShareFokoDialogComponent, {
      data: foko
    });
  }

  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/my-fokos/my-fokos.component.ts